<div class="confirmation-padding">
  <div mat-dialog-title>
    {{ data.title }}
  </div>
  <div mat-dialog-content>
    <form [id]="dialogRef.id + '-form'" [formGroup]="formGroup" autocomplete="on" (submit)="$event.preventDefault(); onPrimaryButton()">
    <div class="message">{{ data.message }}</div>
    <br />
    @if (data.bulletList) {
    <ul>
      @for (message of data.bulletList; track message) {
      <li>
        {{ message }}
      </li>
      }
    </ul>
    } @if (data.messageLista) {
    <div>
      @for (message of data.messageLista; track message) {
      <div class="message-list">
        {{ message }}
      </div>
      }
    </div>
    } @if (data.customActionButton) {
    <div class="custom-action-container">
      <button
        type="button"
        mat-raised-button
        color="primary"
        (click)="onCustomAction()"
        class="custom-action-button"
      >
        {{ data.customActionButton }}
      </button>
    </div>
    } @if (data.useInput) {
    <faxe-input-form
      formCtrlName="input"
      inputType="text"
      inputModeType="text"
      [renderFormElement]="false"
      [requiredInput]="true"
      [parentFormGroup]="formGroup"
    >
    </faxe-input-form>
    } @for (input of data?.inputs; track input) {
    <faxe-input-form
      [formCtrlName]="input.keyValuepair.key"
      [label]="input.label"
      [hint]="input.hint"
      [inputType]="input.inputType || 'text'"
      inputModeType="text"
      [autocomplete]="input.autocomplete || 'off'"
      [name]="input.name || input.keyValuepair.key"
      [renderFormElement]="false"
      [requiredInput]="true"
      [parentFormGroup]="formGroup"
    ></faxe-input-form>
    }
    </form>
  </div>
  <div class="action-buttons">
    <div mat-dialog-actions>
      @if (data.primaryButton) {
      <button
        type="submit"
        [attr.form]="dialogRef.id + '-form'"
        mat-button
        color="primary"
        class="button-margin buttons"
      >
        {{ data.primaryButton }}
      </button>
      } @if (data.secondaryButton === buttons.avbryt) {
      <button
        type="button"
        mat-button
        color="secondary"
        (click)="onSecondaryButton()"
        class="buttons"
      >
        {{ data.secondaryButton }}
      </button>
      }
    </div>
  </div>
</div>
